export const getProceedToOrdinaryProduct = (state) => state.permissionOrdinary.proceedToOrdinaryProduct
